// Hooks / Node modules / Styles
import { Chip } from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function GameCard({ game }) {
  return (
    <div className="local-theme-bg-md local-theme-border-md border rounded-lg shadow-md p-4 flex flex-col h-full">
      <h3 className="text-lg font-semibold local-theme-text-md">{game.title}</h3>

      {/* Game Thumbnail */}
      <div className="w-full h-[180px] mt-2">
        <img
          src={game.image}
          alt={game.title}
          className="w-full h-full object-cover rounded-lg"
        />
      </div>

      {game.engine && (
        <p className="text-sm local-theme-text-xs mt-3">
          <strong>Engine:</strong> {game.engine}
        </p>
      )}
      {game.platform && (
        <p className="text-sm local-theme-text-xs">
          <strong>Platform:</strong> {game.platform}
        </p>
      )}
      {game.category && (
        <p className="text-sm local-theme-text-xs">
          <strong>Category:</strong> {game.category}
        </p>
      )}
      <p className="text-sm local-theme-text-sm mt-2 flex-grow mb-3">
        {game.description}
      </p>

      <a
        href={game.link}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-auto text-blue-600 hover:underline text-center py-2 border-t dark:border-t-dark-400"
      >
        View Product Page
      </a>
    </div>
  );
}

export default GameCard;
